import { useCallback } from 'react';
import { TextCheckbox } from 'taboola-ultimate-ui';
import { FormField } from 'taboola-ultimate-ui';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { SUPPLY_TARGETING_TYPES } from './const';
import { useAPISupplyTargetingRestrictions } from './hooks/useAPISupplyTargetingRestrictions';
import { useIsSupplyTargetingSelectPermitted } from './hooks/useIsSupplyTargetingSelectPermitted';
import styles from './taboolaSelectCheckbox.module.scss';

export const TaboolaSelectCheckbox = () => {
    const { value: taboolaSelect, onChange } = useFormFieldValue({
        field: 'campaignTargeting.taboolaSelect',
    });
    const onSelect = useCallback(() => onChange(true), [onChange]);
    const onUnSelect = useCallback(() => onChange(false), [onChange]);

    const isTaboolaSelectEnabled = useIsSupplyTargetingSelectPermitted();
    const { supplyTargetingResource, isSupplyPermitted } = useAPISupplyTargetingRestrictions();
    const isPermitted = !isSupplyPermitted && isTaboolaSelectEnabled;
    const isVisible =
        supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.TABOOLA_SELECT]?.isVisible || taboolaSelect === true;
    const isDisabled = !supplyTargetingResource?.[SUPPLY_TARGETING_TYPES.TABOOLA_SELECT]?.isEditable;

    if (!isPermitted || !isVisible) {
        return null;
    }

    return (
        <FormField containerClass={styles['container']}>
            <TextCheckbox
                inputClassName={styles['check-box']}
                labelClassName={styles['label']}
                value={!!taboolaSelect}
                title={
                    <FormattedMessage
                        id={`campaign.editor.targeting.supply.checkbox.${SUPPLY_TARGETING_TYPES.TABOOLA_SELECT}`}
                        defaultMessage="Select: A curated selection of our most premium MFA-free publishers and placements, ensuring guaranteed ad adjacency."
                    />
                }
                onSelectCheckbox={onSelect}
                onUnselectCheckbox={onUnSelect}
                selectedValues={[true]}
                disabled={isDisabled}
                independent
            />
        </FormField>
    );
};
